export const DEFAULT_LANGUAGE = "ar"; // default language if not defined
export const DEFAULT_USER_IMAGE = "/images/users/default-user.png"; // default user image if not defined
export const API_URL = process.env.REACT_APP_API_URL; // api link by the environment
export const STORAGE_URL = process.env.REACT_APP_STORAGE_URL; // storage link by the environment
export const GENERAL_TOKEN = process.env.REACT_APP_GENERAL_TOKEN; // general token by the environment